import React, { useMemo, memo } from 'react';
import { makeStyles } from 'tss-react/mui';
import AppRoutes from '../AppRoutes';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import { MediaQuery } from '../../constants/MediaQuerySizes';
import MobileLayout from './MobileLayout';
import DesktopLayout from './DesktopLayout';
import { useEffect } from 'react';

const useStyles = makeStyles()((theme) => ({
  content: {
    flexGrow: 1,
    marginTop: '25px',
    padding: theme.spacing(3),
    [theme.breakpoints.down(500)]: {
      overflow: 'hidden',
    },
  },
}));

const Layout = ({ loggedIn, logOutPress, logInPress, accountDetails }) => {
    const { classes } = useStyles();
    const location = useLocation();
    const navigate = useNavigate();
    const isDesktopResolution = useMediaQuery(`(min-width: ${MediaQuery.MIN_DESKTOP}px)`);

    useEffect(() => {
        if (!isDesktopResolution && location.pathname.includes("/create"))
            navigate('/videos');
    }, [isDesktopResolution])

    const layoutProps = useMemo(() => ({
        loggedIn,
        logOutPress,
        logInPress,
        accountDetails
    }), [loggedIn, logOutPress, logInPress, accountDetails]);

    const content = useMemo(() => (
        <main className={classes.content}>
            <AppRoutes />
        </main>
    ), [classes.content]);


    if (location.pathname.includes("/create") || isDesktopResolution && location.pathname.includes("/exports") && !location.pathname.includes("/admin"))
        return <>{content}</>

    if (isDesktopResolution) {
        return <DesktopLayout {...layoutProps}>{content}</DesktopLayout>;
    } else {
        return <MobileLayout>{content}</MobileLayout>;
    }
}

export default memo(Layout);